import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const BusinessFormFields = ({ formData, handleInputChange, handleSelectChange, towns, categories }) => (
  <div className="bg-[#F7F6F2] border-2 border-[#D1CFC5] rounded-xl p-6 md:p-8">
    <h2 className="font-heading text-2xl font-semibold text-[#1A1915] mb-6">Business Details</h2>
    <div className="grid md:grid-cols-2 gap-6">
      <div>
        <Label className="text-[#1A1915]">Business Name *</Label>
        <Input name="name" value={formData.name} onChange={handleInputChange} className="mt-1 bg-white border-[#D1CFC5]" required data-testid="input-name" />
      </div>
      <div>
        <Label className="text-[#1A1915]">Owner / Contact Name</Label>
        <Input name="owner_name" value={formData.owner_name} onChange={handleInputChange} className="mt-1 bg-white border-[#D1CFC5]" data-testid="input-owner" />
      </div>
      <div>
        <Label className="text-[#1A1915]">Email *</Label>
        <Input name="email" type="email" value={formData.email} onChange={handleInputChange} className="mt-1 bg-white border-[#D1CFC5]" required data-testid="input-email" />
      </div>
      <div>
        <Label className="text-[#1A1915]">Phone</Label>
        <Input name="phone" value={formData.phone} onChange={handleInputChange} className="mt-1 bg-white border-[#D1CFC5]" data-testid="input-phone" />
      </div>
      <div>
        <Label className="text-[#1A1915]">Website</Label>
        <Input name="website" value={formData.website} onChange={handleInputChange} className="mt-1 bg-white border-[#D1CFC5]" data-testid="input-website" />
      </div>
      <div>
        <Label className="text-[#1A1915]">Address</Label>
        <Input name="address" value={formData.address} onChange={handleInputChange} className="mt-1 bg-white border-[#D1CFC5]" data-testid="input-address" />
      </div>
      <div>
        <Label className="text-[#1A1915]">Town *</Label>
        <Select value={formData.town} onValueChange={(v) => handleSelectChange("town", v)}>
          <SelectTrigger className="mt-1 bg-white border-[#D1CFC5]" data-testid="select-town"><SelectValue placeholder="Select town" /></SelectTrigger>
          <SelectContent>{towns.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-[#1A1915]">Category *</Label>
        <Select value={formData.category} onValueChange={(v) => handleSelectChange("category", v)}>
          <SelectTrigger className="mt-1 bg-white border-[#D1CFC5]" data-testid="select-category"><SelectValue placeholder="Select category" /></SelectTrigger>
          <SelectContent>{categories.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="md:col-span-2">
        <Label className="text-[#1A1915]">Description *</Label>
        <Textarea name="description" value={formData.description} onChange={handleInputChange} className="mt-1 bg-white border-[#D1CFC5]" rows={4} required data-testid="input-description" />
      </div>
      <div className="md:col-span-2">
        <Label className="text-[#1A1915]">Business Hours</Label>
        <Input name="hours" value={formData.hours} onChange={handleInputChange} className="mt-1 bg-white border-[#D1CFC5]" placeholder="e.g. Mon-Fri 9am-5pm" data-testid="input-hours" />
      </div>
    </div>
  </div>
);
